import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerDetail = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueBookingTabs, setValueBookingTabs] = useState(0);
  const handleChangeBookingTabs = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValueBookingTabs(newValue);
  };

  const [loyaltyPoints] = React.useState<number>(1200);
  const [rows] = useState([
    {
      id: "B001",
      serviceDetails: "Hair Color",
      dateTime: "2025-08-22 10:00 AM - 12:00 PM",
      notes: "Bring extra tools",
      customerAddress: "123 Main Street, City",
      providerAddress: "456 Service Lane, City",
      providerDetails: "Hair Razors",
      price: "AED 200",
      type: "In-Home",
      status: "Pending",
      review: "Waiting for service completion",
      rating: "-",
    },
    {
      id: "B002",
      serviceDetails: "Hair Wash",
      dateTime: "2025-08-23 2:00 PM - 4:00 PM",
      notes: "Wash with good shampoo",
      customerAddress: "789 Green Park, City",
      providerAddress: "321 Water Street, City",
      providerDetails: "Salon Elegance",
      price: "AED 300",
      type: "Upcoming",
      status: "Upcoming",
      review: "Not yet started",
      rating: "-",
    },
    {
      id: "B003",
      serviceDetails: "Makeup",
      dateTime: "2025-08-18 3:00 PM - 5:00 PM",
      notes: "Bridal makeup",
      customerAddress: "45 Downtown, City",
      providerAddress: "87 Glam Street, City",
      providerDetails: "Glow Studio",
      price: "AED 1200",
      type: "In-Store",
      status: "Completed",
      review: "Excellent service!",
      rating: "5/5",
    },
    {
      id: "B004",
      serviceDetails: "Spa Therapy",
      dateTime: "2025-08-20 11:00 AM - 1:00 PM",
      notes: "Aroma oils",
      customerAddress: "55 Lakeview, City",
      providerAddress: "22 Relax Ave, City",
      providerDetails: "Wellness Hub",
      price: "AED 500",
      type: "In-Store",
      status: "Cancelled",
      cancelledBy: "Admin",
      cancelledOn: "2025-08-19 05:45 PM",
      cancellationReason: "Service provider unavailable",
      review: "Could not experience service",
      rating: "-",
    },
  ]);

  const columns = [
    { id: "id", label: "Booking ID" },
    { id: "serviceDetails", label: "Service Details" },
    { id: "dateTime", label: "Selected Date & Time Slot" },
    { id: "notes", label: "Notes" },
    { id: "price", label: "Total Price" },
    { id: "customerAddress", label: "Customer Address" },
    { id: "providerAddress", label: "Service Provider Address" },
    { id: "providerDetails", label: "Service Provider Details" },
    { id: "type", label: "Type" },
    { id: "review", label: "Review" },
    { id: "rating", label: "Rating" },
  ];

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-Users")}>User Management</button>{" "}
          - Customer Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Booking History" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="section_title">
            <h2>Personal Info</h2>
          </div>
          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img alt="user" src="/static/images/user_placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Name</h6>
              <p>Madelyn Dias</p>
            </div>
            <div className="w_33">
              <h6>Email</h6>
              <p>madelyndias@gmail.com</p>
            </div>
            <div className="w_33">
              <h6>Phone</h6>
              <p>9876543210</p>
            </div>
            <div className="w_33">
              <h6>Loyalty Points</h6>
              <p>{loyaltyPoints}</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Booking History */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <Box className=" custom_tabs" sx={{ width: "100%", marginBottom: 2 }}>
            <Tabs
              value={valueBookingTabs}
              onChange={handleChangeBookingTabs}
              aria-label="booking tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Upcoming" {...a11yProps(1)} />
              <Tab label="Completed" {...a11yProps(2)} />
              <Tab label="Cancelled" {...a11yProps(3)} />
            </Tabs>
          </Box>

          {/* Pending */}
          <CustomTabPanel value={valueBookingTabs} index={0}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell key={col.id}>{col.label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .filter((row) => row.status === "Pending")
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((col) => (
                          <TableCell key={col.id}>
                            {row[col.id as keyof typeof row]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>

          {/* Upcoming */}
          <CustomTabPanel value={valueBookingTabs} index={1}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell key={col.id}>{col.label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .filter((row) => row.status === "Upcoming")
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((col) => (
                          <TableCell key={col.id}>
                            {row[col.id as keyof typeof row]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>

          {/* Completed */}
          <CustomTabPanel value={valueBookingTabs} index={2}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell key={col.id}>{col.label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .filter((row) => row.status === "Completed")
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((col) => (
                          <TableCell key={col.id}>
                            {row[col.id as keyof typeof row]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>

          {/* Cancelled */}
          <CustomTabPanel value={valueBookingTabs} index={3}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell key={col.id}>{col.label}</TableCell>
                    ))}
                    <TableCell>Cancelled By</TableCell>
                    <TableCell>Cancelled On</TableCell>
                    <TableCell>Cancellation Reason</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .filter((row) => row.status === "Cancelled")
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((col) => (
                          <TableCell key={col.id}>
                            {row[col.id as keyof typeof row]}
                          </TableCell>
                        ))}
                        <TableCell>{row.cancelledBy}</TableCell>
                        <TableCell>{row.cancelledOn}</TableCell>
                        <TableCell>{row.cancellationReason}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageCustomerDetail;
